import { MenuItem } from "@blueprintjs/core";
import { Suggest } from "@blueprintjs/select";
import { Box, InlineSpinnerIcon } from "ui-components";
import { useDebouncedValue } from "ui-lib";
import React, { useState, useMemo } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import companySearchQuery, {
  DashboardCompanySearch,
} from "ui-io/queries/dashboard-company-search-query";
import { formatLocation } from "../../../routes";
const SelectConfig = Suggest.ofType<DashboardCompanySearch>();

const SearchCompany = (props: {
  placeholder?: string;
}) => {
  const history = useNavigate();
  const [searchKey, setSearchKey] = useState("");
  const [selectedCompanyID, setSelectedCompanyID] = useState<string>("");
  const debouncedSearch = useDebouncedValue(searchKey);

  const getSeparatedSearchKey = (key: string) => {
    const valToSeprate = key.split(" ")[0];
    return valToSeprate.split("").join("_");
  };
  const queryObj = useMemo(() => {
    if (Number.isNaN(Number(debouncedSearch))) {
      return {
        searchKey: debouncedSearch.toLowerCase(),
        separatedSearchKey: getSeparatedSearchKey(debouncedSearch),
      };
    } else {
      return { searchKey: debouncedSearch };
    }
  }, [debouncedSearch]);

  const connection = useQuery({
    ...companySearchQuery({ ...queryObj }),
    enabled: !!queryObj.searchKey.length,
  });

  const configNameList = connection.isSuccess && connection.data;
  const addCompanyIdAtUrl = (value: any) => {
    history(
      formatLocation.companyDetails({
        companyID: value.companyID,
      })
    );
  };

  return (
    <Box mr={1}>
      <SelectConfig
        inputProps={{
          style: { boxShadow: "inset 0 0 0 1px lightslategray" },
          round: true,
          inputClassName: "w-400",
          rightElement: (
            <img
              src="/icons/search.svg"
              alt="search"
              height={20}
              width={20}
              style={{ marginRight: 8, marginTop: 10 }}
            />
          ),
          placeholder: props?.placeholder
            ? props.placeholder
            : "Search",
          size: "large",
        }}
        closeOnSelect
        onQueryChange={setSearchKey}
        items={configNameList ? configNameList : []}
        noResults={
          connection.isLoading ? (
            <InlineSpinnerIcon />
          ) : (
            <MenuItem
              disabled={true}
              text="No results"
            />
          )
        }
        onItemSelect={
          props?.placeholder
            ? (value: any) => setSelectedCompanyID(value.companyID)
            : addCompanyIdAtUrl
        }
        itemRenderer={(item, itemProps) => (
          <MenuItem
            key={item.companyID}
            active={itemProps.modifiers.active}
            text={item.name}
            onClick={itemProps.handleClick}
          />
        )}
        inputValueRenderer={(value) => value.name}
        popoverProps={{ modifiers:{ arrow: { enabled: false } }, popoverClassName: "w-370 ml-md mr-md" }}
      />
    </Box>
  );
};
export default SearchCompany;
